import { default as MainCtrl } from '../controllers/main-ctrl';
import { default as AuthCtrl } from '../controllers/auth-ctrl';
import { default as ProfileCtrl	} from '../components/accounts/profile/profile-ctrl';
import { default as MegaNavCtrl } from '../controllers/mega-nav-ctrl';
import { default as PaymentCtrl } from '../components/payments/payment-ctrl';
import { default as DashboardCtrl } from '../components/dashboard/dashboard-ctrl';
import { default as RegisterCtrl } from '../components/accounts/register/register-ctrl';
import { default as LevyRollCtrl } from '../components/financials/levy-roll/levy-roll-ctrl';
import { default as ClearanceCaptureCtrl } from '../components/clearances/clearance-capture-ctrl';
import { default as ClearanceRequestCtrl } from '../components/clearances/clearance-request/clearance-request-ctrl';
import { default as BalanceSheetCtrl } from '../components/financials/balance-sheet/balance-sheet-ctrl';
import { default as PersonalDocumentsCtrl } from '../components/personal-documents/personal-documents-ctrl';
import { default as BuildingDocumentsCtrl } from '../components/building-documents/building-documents-ctrl';
import { default as AccountsHistoryCtrl } from '../components/accounts/accounts-history/accounts-history-ctrl';
import { default as ContractorsRollCtrl } from '../components/financials/contractors-roll/contractors-roll-ctrl';
import { default as IncomeStatementCtrl } from '../components/financials/income-statement/income-statement-ctrl';
import { default as FinancialSummaryCtrl } from '../components/financials/financial-summary/financial-summary-ctrl';
import { default as PaymentAuthorisationCtrl } from '../components/payment-authorisation/payment-authorisation-ctrl';
import { default as CashflowStatementCtrl } from '../components/financials/cashflow-statement/cashflow-statement-ctrl';
import { default as CashflowStatementNewCtrl } from '../components/financials/cashflow-statement-new/cashflow-statement-new-ctrl';
import { default as IncomeVSBudgetCtrl } from '../components/financials/income-vs-budget/income-vs-budget-ctrl';
import { default as DebtorAgeAnalysisCtrl } from '../components/financials/debtor-age-analysis/debtor-age-analysis-ctrl';
import { default as TenantCtrl } from '../components/accounts/tenant/tenant-ctrl';
import { default as ComplianceCtrl } from '../components/compliance/compliance-ctrl';
import { default as UtilityinfoCtrl } from '../components/utility-info/utility-info-ctrl';
import { default as DocumentsApprovalCtrl } from '../components/approval-documents/documents-approval-ctrl';
import { default as LoginCtrl	} from '../components/accounts/login/login-ctrl';
import { default as SetPasswordCtrl } from '../components/accounts/set-password/set-password-ctrl';
import { default as HistoricalLinkCtrl	} from '../components/accounts/historical-link/historical-link-ctrl';
import { default as AuditsCaptureCtrl } from '../components/audits/audits-capture-ctrl';
import { default as AuditorsDashboardCtrl } from '../components/auditors-dashboard/auditors-dashboard-ctrl';
import { default as RentalsCaptureCtrl } from '../components/rentals/rentals-capture-ctrl';
import { default as WagesRollCtrl } from '../components/financials/wages-roll/wages-roll-ctrl';
import { default as TrusteeDashboardCtrl } from '../components/trustee-dashboard/trustee-dashboard-ctrl';
import { default as FindAContractorCtrl } from '../components/contractors/find-a-contractor-ctrl';


export default angular
    .module('pretor.online.controllers', [])
    .controller('MainCtrl', MainCtrl)
    .controller('AuthCtrl', AuthCtrl)
    .controller('TenantCtrl', TenantCtrl)
    .controller('ProfileCtrl', ProfileCtrl)
    .controller('MegaNavCtrl', MegaNavCtrl)
    .controller('PaymentCtrl', PaymentCtrl)
    .controller('LevyRollCtrl', LevyRollCtrl)
    .controller('RegisterCtrl', RegisterCtrl)
    .controller('DashboardCtrl', DashboardCtrl)
    .controller('ComplianceCtrl', ComplianceCtrl)
    .controller('BalanceSheetCtrl', BalanceSheetCtrl)
    .controller('IncomeStatementCtrl', IncomeStatementCtrl)
    .controller('IncomeVSBudgetCtrl', IncomeVSBudgetCtrl)
    .controller('DebtorAgeAnalysisCtrl', DebtorAgeAnalysisCtrl)
    .controller('AccountsHistoryCtrl', AccountsHistoryCtrl)
    .controller('ContractorsRollCtrl', ContractorsRollCtrl)
    .controller('ClearanceCaptureCtrl', ClearanceCaptureCtrl)
    .controller('ClearanceRequestCtrl', ClearanceRequestCtrl)
    .controller('FinancialSummaryCtrl', FinancialSummaryCtrl)
    .controller('BuildingDocumentsCtrl', BuildingDocumentsCtrl)
    .controller('CashflowStatementCtrl', CashflowStatementCtrl)
    .controller('CashflowStatementNewCtrl', CashflowStatementNewCtrl)
    .controller('PersonalDocumentsCtrl', PersonalDocumentsCtrl)
    .controller('BuildingDocumentsCtrl', BuildingDocumentsCtrl)
    .controller('PaymentAuthorisationCtrl', PaymentAuthorisationCtrl)
    .controller('UtilityinfoCtrl',UtilityinfoCtrl)
    .controller('DocumentsApprovalCtrl',DocumentsApprovalCtrl)
    .controller('LoginCtrl',LoginCtrl)
    .controller('SetPasswordCtrl',SetPasswordCtrl)
    .controller('HistoricalLinkCtrl',HistoricalLinkCtrl)
    .controller('AuditsCaptureCtrl',AuditsCaptureCtrl)
    .controller('AuditorsDashboardCtrl',AuditorsDashboardCtrl)
    .controller('RentalsCaptureCtrl',RentalsCaptureCtrl)
    .controller('WagesRollCtrl', WagesRollCtrl)
    .controller('TrusteeDashboardCtrl', TrusteeDashboardCtrl)
    .controller('FindAContractorCtrl', FindAContractorCtrl);